import React from "react";
import styles from "./Tooltip.module.scss";
import "./Tooltip.scss";
import "react-tippy/dist/tippy.css";
import {Tooltip} from "react-tippy";
import imageGroup from "../../../assets/img/icons/info.svg";

class TooltipComponent extends React.Component<any, any> {
  render() {
    return (
      <div className={styles.padding}>
        <Tooltip
          arrow
          position="top-start"
          trigger="mouseenter"
          html={(
            <div className={styles.content}>
              {this.props.children}
            </div>
          )}>
          <p>
            <img src={imageGroup} alt="info"/>
          </p>
        </Tooltip>

      </div>
    );
  }
}

export default TooltipComponent;
